import type { AppRole } from '../types/organization.types';

export const permissionService = {
  hasRole(currentRole: AppRole | null | undefined, requiredRole: AppRole): boolean {
    if (!currentRole) return false;
    return currentRole === requiredRole;
  },

  hasAnyRole(currentRole: AppRole | null | undefined, requiredRoles: AppRole[]): boolean {
    if (!currentRole) return false;
    return requiredRoles.includes(currentRole);
  },

  canManageCampaigns(currentRole: AppRole | null | undefined): boolean {
    return this.hasAnyRole(currentRole, ['admin', 'talent_manager']);
  },

  canManageInfluencers(currentRole: AppRole | null | undefined): boolean {
    return this.hasAnyRole(currentRole, ['admin', 'talent_manager', 'content_strategist']);
  },

  canManagePayments(currentRole: AppRole | null | undefined): boolean {
    return this.hasAnyRole(currentRole, ['admin', 'finance']);
  },

  canManageBrands(currentRole: AppRole | null | undefined): boolean {
    return this.hasAnyRole(currentRole, ['admin', 'account_executive', 'account_manager']);
  },

  canManageContacts(currentRole: AppRole | null | undefined): boolean {
    return this.hasAnyRole(currentRole, ['admin', 'account_executive', 'account_manager']);
  },

  canManageTemplates(currentRole: AppRole | null | undefined): boolean {
    return this.hasAnyRole(currentRole, ['admin', 'talent_manager']);
  },

  isAdmin(currentRole: AppRole | null | undefined): boolean {
    return this.hasRole(currentRole, 'admin');
  },
};
